import type { CaixaResumo } from "../../../services/historicoCaixa"

export enum HistoricoCaixaActionsTypes {
    CARREGAR = "CARREGAR",
}

export type HistoricoCaixaActions = {
    type: HistoricoCaixaActionsTypes.CARREGAR
    payload: CaixaResumo[]
}
